import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DecoderHeader } from "@/components/DecoderHeader";
import { startGoogleLogin } from "@/context/AuthContext";

const FEATURES = [
  "Full sonic breakdown: genre, BPM, key, instruments, structure",
  "Detailed vocal sound + style baked into every prompt",
  "Original lyrics in the same style, generated automatically",
  "Choose clean or explicit (18+) lyrics before every decode",
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#09090B] grid-bg" data-testid="landing-page">
      <DecoderHeader />
      <main className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24 grid lg:grid-cols-12 gap-12">
        <section className="lg:col-span-7">
          <div className="font-mono-display text-[11px] tracking-[0.35em] uppercase text-emerald-500 mb-4">[ audio :: reverse_engineered ]</div>
          <h1 className="font-mono-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] mb-6">
            Decode any song.<br /><span className="text-emerald-500">Get the Suno prompt.</span>
          </h1>
          <ul className="space-y-3 mb-10">
            {FEATURES.map((f) => (
              <li key={f} className="flex gap-3 text-zinc-300"><Check className="w-5 h-5 text-emerald-500 shrink-0" />{f}</li>
            ))}
          </ul>
          <Button
            onClick={startGoogleLogin}
            data-testid="google-login-btn"
            className="rounded-none bg-emerald-500 hover:bg-emerald-400 text-black font-mono-display text-xs tracking-[0.25em] uppercase font-bold h-14 px-8"
          >
            Sign in with Google <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
          <p className="mt-4 font-mono-display text-[11px] text-zinc-500 tracking-wide">Your first decode is free.</p>
        </section>
        <aside className="lg:col-span-5 space-y-4" data-testid="landing-pricing">
          {[
            ["free", "$0", "1 decode on sign-up", "border-white/10"],
            ["decode packs", "$1 / decode", "Packs from 5 to 100 decodes. No subscription, decodes never expire.", "border-emerald-500/50"],
            ["best value", "$100 → 120", "The 100 pack comes with 20 bonus decodes", "border-fuchsia-400/50"],
          ].map(([name, price, desc, border]) => (
            <div key={name} className={`border ${border} bg-zinc-900/40 p-6 rounded-sm`}>
              <div className="font-mono-display text-[10px] tracking-[0.3em] uppercase text-zinc-500">{name}</div>
              <div className="font-mono-display text-3xl font-black mt-1">{price}</div>
              <div className="text-sm text-zinc-400 mt-1">{desc}</div>
            </div>
          ))}
        </aside>
      </main>
    </div>
  );
}
